import React, { useCallback, useEffect, useState } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { Box, CssBaseline } from "@mui/material";
import DashboardLayout from "./Components/Dashboard/DashboardLayout";
import "./App.css";
import { NotFound } from "./FrontEnd/NotFound";
import {
  callAPI,
  LoacalVariables,
  Method,
  setLocalValues
} from "./commonFunctions/CommonFunctions";
import ProtectedRoute from "./ProtectedRoute";
// import {BounceLoader} from 'react-spinners'
import logo from "./images/willsoar.svg";

//route imports;
import ClientList from "./FrontEnd/Clients/ClientList";
import EstimateList from "./FrontEnd/Estimates/EstimateList";
import EmployeeList from "./FrontEnd/Employees/EmployeeList";
import RateCardList from "./FrontEnd/RateCards/RateCardList";
import MyAccount from "./FrontEnd/MyAccount/MyAccount";
import Unauthorized from "./FrontEnd/Unauthorized";
import LoginForm from "./FrontEnd/Authentication/Login";
import ForgotPassword from "./FrontEnd/Authentication/ForgotPassword";
import ResetPassword from "./FrontEnd/Authentication/ResetPassword";
import Registration from "./FrontEnd/Authentication/Registration";
import Employee from "./FrontEnd/Employees/Employee";
import http from "./commonFunctions/httpClient";
import { useAuth } from "./StateManagement/authContext";
import { setAuthContext } from "./commonFunctions/util";
import SplashScreen from "./Components/wsSpashScreen";
import QuotationList from "./FrontEnd/Quotations/QuotationList";
import LeaveRequestManager from "./FrontEnd/LeaveRequest/LeaveRequestList";
import SettingsPage from "./FrontEnd/Settings/Settings";

// "apiBaseUrl": "https://simplestimateserver.onrender.com/api/",

const App: React.FC = () => {
  const auth = useAuth();
  const location = useLocation();

  const publicRoutes = ['/login', '/register', '/forgot/password', '/reset/password'];
  
  useEffect(() => {
    if (!publicRoutes.includes(location.pathname)) {
      setAuthContext(auth); // Only set global context in protected routes
    }
  }, [auth, location.pathname]);

useEffect(() => {
  let interval: any;

  const startInterval = () => {
    interval = setInterval(() => {
      http.get("auth/refresh-token").catch(() => {
        console.warn("Auto refresh failed");
      });
    }, 10 * 60 * 1000); //every 10 minutes;
  };

  if (document.visibilityState === "visible") {
    startInterval();
  }

  const handleVisibilityChange = () => {
    if (document.visibilityState === "visible") {
      startInterval();
    } else {
      clearInterval(interval);
    }
  };

  document.addEventListener("visibilitychange", handleVisibilityChange);

  return () => {
    clearInterval(interval);
    document.removeEventListener("visibilitychange", handleVisibilityChange);
  };
}, []);



if(auth.loading){
  return <SplashScreen />
}
  

//   const checkAuth = useCallback(async () => {
//     try {
//       setLoading(true);
//       const res = await callAPI("auth/verify", Method.GET, {
//         withCredentials: true
//       });
//       if (res?.success) {
//         setIsAuthenticated(true);
//         setLocalValues(LoacalVariables.UserId, res.user._id);
//         setLocalValues(LoacalVariables.UserType, res.user.userType);
//         setLocalValues(
//           LoacalVariables.Name,
//           `${res.user.fname} ${res.user.lname}`
//         );
//       } else {
//         setIsAuthenticated(false);
//       }
//     } catch {
//       setIsAuthenticated(false);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//  useEffect(() => {
//   const publicRoutes = ['/login', '/register']; // Moved inside useEffect
//   if (!publicRoutes.includes(location.pathname)) {
//     checkAuth();
//   } else {
//     setLoading(false);
//   }
// }, []);


//   if (loading)
//   return (
//     <Box
//   height="100vh"
//   display="flex"
//   justifyContent="center"
//   alignItems="center"
//   flexDirection="column"
//   className="fade-in"
// >
//   <img src={logo} alt="Logo" height={75} width={150} />
// </Box>

//   );

  return (
    <>
     <CssBaseline />
      <Routes>
        <Route
          path="/"
          element={
            auth.isAuthenticated ? (
              <DashboardLayout />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        >
          <Route index element={<EstimateList />} />

          <Route element={<ProtectedRoute isAuthenticated={auth.isAuthenticated} />}>
            {/* Common Routes (All Auth Roles) */}
            <Route path="estimates" element={<EstimateList />} />
            <Route path="quotations" element={<QuotationList />} />
            <Route path="myAccount/:id" element={<MyAccount />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route
              element={
                <ProtectedRoute
                  isAuthenticated={auth.isAuthenticated}
                  allowedRoles={["admin"]}
                />
              }
            >
              {/* employee management */}
              <Route path="employees/list" element={<EmployeeList />} />
              <Route path="employee/:id?" element={<Employee />} />
              <Route
               path="/registration"
               element={<Registration />}
              />

              <Route
          path="/forgot/password"
          element={<ForgotPassword />}
        />
        <Route
          path="/reset/password"
          element={<ResetPassword />}
        />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  isAuthenticated={auth.isAuthenticated}
                  allowedRoles={["admin", "project_manager"]}
                />
              }
            >
              {/* Client and RateCard management */}
              <Route path="clients" element={<ClientList />} />
              <Route path="ratecards" element={<RateCardList />} />
            </Route>

{/* employ protectd; */}
            <Route element={<ProtectedRoute isAuthenticated={auth.isAuthenticated} allowedRoles={["employee"]}/>}>
               <Route path="leave/request" element={<LeaveRequestManager />} />
            </Route>
          </Route>
        </Route>

        {/* Public Routes */}
        <Route
          path="/login"
          element={auth.isAuthenticated ? <Navigate to="/" /> : <LoginForm />}
        />
        <Route
          path="/forgot/password"
          element={<ForgotPassword />}
        />
        <Route
          path="/reset/password"
          element={<ResetPassword />}
        />
  
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default App;
